export interface EduContentMetadataRelationInterface {
  id?: number;
  sourceEduContentMetadataId?: number;
  targetEduContentId?: number;
  targetEduContentMetadataId?: number;
  type?: RelationType;
  title?: string;
  isDraft?: boolean;
  isPublished?: boolean;
}

export enum RelationType {
  SOLUTION = 'Oplossing',
}
